<template>
  <div>
    <logged-in-header />
    <create-organization-panel />
    <empower-footer />
    <whats-app />
  </div>
</template>

<script>
import loggedInHeader from "../../components/commom/LoggedInHeader";
import createOrganizationPanel from "../../components/organization/CreateOrganizationPanel";
import empowerFooter from "../../components/commom/EmpowerFooter";
import WhatsApp from "../../components/commom/WhatsApp";

export default {
  components: {
    loggedInHeader,
    createOrganizationPanel,
    empowerFooter,
    WhatsApp
  }
};
</script>
